export const ROUTES_TRANSLATIONS = {
    routes: {
        metas: {
            new: "",
            update: "",
            default: "",
            visualization: "",
            single: ":id",
        },

        genericRoutes: {
            new: 'new',
            empty: '',
            single: ':id',
            dictionaries: 'dictionaries'
        },
        allRoutePrefix: {
            configurations: 'configurations',
            admin: 'admin',
            account: "account"
        },

        configurations: {
            path: '/configurations',
            default: '',
            data: {
                breadcrumbName: "",
                metas: {}
            }
        },

        myProfile: {
            path: "/my-profile",
            admin: {
                path: "/admin/my-profile"
            },
            account: {
                path: "/account/my-profile"
            },
            default: "",
            data: {
                breadcrumbName: "",
                metas: {}
            }
        },
        passwordReset: {
            path: "/forgot-my-password",
            default: "",
            data: {
                breadcrumbName: "",
                metas: {}
            }
        },
        passwordEdit: {
            path: "/change-password",
            default: "",
            data: {
                breadcrumbName: "",
                metas: {}
            }
        },

        admin: {
            accounts: {
                path: "/admin/accounts",
                data: {
                    breadcrumbName: "",
                    metas: {}
                },
                permissions: {
                    path: "users/:userId/permissions"
                },
                dictionaries: {
                    list: 'dictionaries',
                    new: 'new',
                    single: ':dictionaryId'
                }
            },
            admins: {
                path: "/admin/administrators",
                data: {
                    breadcrumbName: "",
                    metas: {}
                },
            },
            login: {
                path: "/admin/login",
                empty: "",
                nextPath: "next-path",
                default: "",
                data: {
                    breadcrumbName: "",
                    metas: {}
                },
            },
        },
        account: {
            users: {
                path: "/account/users",
                data: {
                    breadcrumbName: "",
                    metas: {}
                },
            },
            complaints: {
                path: "/account/complaints",
                data: {
                    breadcrumbName: "",
                    metas: {}
                },
            },
            categories: {
                path: "/account/categories",
                data: {
                    breadcrumbName: "",
                    metas: {}
                },
            },
            committees: {
                path: "/account/committees",
                data: {
                    breadcrumbName: "",
                    metas: {}
                },
            },
        },

        login: {
            path: "/login",
            empty: "",
            nextPath: "next-path",
            default: "",
            data: {
                breadcrumbName: "",
                metas: {}
            },
        },

        home: {
            path: "/",
            empty: "",
            nextPath: "next-path",
            default: "",
            data: {
                breadcrumbName: "",
                metas: {}
            }
        },

        welcome: {
            path: "/welcome",
            empty: "",
            default: "",
            data: {
                breadcrumbName: "",
                metas: {}
            }
        },

        complaintsMenu: {
            path: "/complaints-menu",
            empty: "",
            default: "",
            data: {
                breadcrumbName: "",
                metas: {}
            },
            followUp: {
                path: "follow-up",
                fullPath: "/complaints-menu/follow-up",
                data: {
                    breadcrumbName: "",
                    metas: {}
                },
            },
            single: {
                path: "follow-up/:id",
                data: {
                    breadcrumbName: "",
                    metas: {}
                },
            },
            new: {
                data: {
                    breadcrumbName: "",
                    metas: {}
                },
            },
            womanChannel: {
                path: "woman-channel",
                data: {
                    breadcrumbName: "",
                    metas: {}
                },
            }
        },
        notFound: {
            path: "/not-found",
            anything: "**",
            default: "",
            data: {
                breadcrumbName: "",
                metas: {}
            }
        },
        noAccess: {
            path: "/no-access-permission",
            default: "",
            data: {
                breadcrumbName: "",
                metas: {}
            }
        },
        charges: {
            path: "/charges",
            data: {
                breadcrumbName: "",
                metas: {}
            }
        },

        admins: {
            languages: {
                path: "/admins/languages",
                data: {
                    breadcrumbName: "",
                    metas: {}
                }
            }
        }
    },
};
